const parse = (v: string) =>
    String(v)
        .trim()
        .replace(/^v/i, '')
        .split('-')[0]
        .split('.')
        .map((n) => parseInt(n, 10) || 0)

/** Compara versões semver (major.minor.patch). Retorna >0 se a > b, <0 se a < b e 0 se iguais. */
export function compareVersions(a: string, b: string): number {
    const pa = parse(a)
    const pb = parse(b)
    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
        const diff = (pa[i] ?? 0) - (pb[i] ?? 0)
        if (diff !== 0) return diff
    }
    return 0
}
